{
  "version": 1,
  "asset_id": "7d469705-4255-4b16-987f-8aea300cc203",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7d469705-4255-4b16-987f-8aea300cc203/sleeve-amateur-2-440.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7d469705-4255-4b16-987f-8aea300cc203/sleeve-amateur-2-440.webp",
  "original_filename": "sleeve-amateur-2-440.webp",
  "size": 24148,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:31Z"
}
